<template>
  <div class="table-row">
    <div class="table-unit table-desc-unit">
      {{ name }}
      <template v-for="label in labels">
        <span style="float: right">{{ label }}</span
        ><br />
      </template>
    </div>

    <div
      class="table-unit"
      :class="{
        current:
          design.id === editableDesign.id && editableDesignFieldName === name,
        changed:
          viewInput(designs[0]) !== viewInput(design) && highlightDifferences
      }"
      v-for="(design, index) in designs"
      v-if="design"
      @click.stop="index === 0 ? false : open(design)"
    >
      <span v-html="viewInput(design)"></span>
      <roe-tooltip
        v-if="tooltipData(design)"
        class="design-table"
        :text="tooltipData(design)"
      ></roe-tooltip>
    </div>

    <roe-modal
      wrap-class="right-panel-wrap"
      ref="rightPanel"
      :close-on-click-outside="false"
    >
      <div class="right-panel secondary" v-click-outside="close">
        <div class="primary">
          <div class="right-panel-header">
            <h2>{{ name }}</h2>
          </div>

          <div class="right-panel-content">
            <slot
              v-if="$refs.rightPanel && $refs.rightPanel.isOpenState"
            ></slot>
          </div>

          <div class="right-panel-actions">
            <button class="btn-primary" @click="save()">Save</button>
            <button class="btn-secondary" @click="close()">Cancel</button>
          </div>
        </div>
        <div class="right-panel-secondary-content">
          <div class="right-panel-secondary-content-header">
            <h4>Survey</h4>
          </div>
          <slot name="survey"></slot>
        </div>
      </div>
    </roe-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ALTERNATIVE_DESIGN_UPDATE } from "@/store/actions.type";
import {
  SHOW_FORM_ERRORS,
  HIDE_FORM_ERRORS,
  ALTERNATIVE_DESIGNS_RESET_EDITABLE,
  ALTERNATIVE_DESIGNS_EDIT,
  SET_INVALID_FORM_STATE,
  FLASH_MESSAGE_SET_POSITION,
  FLASH_MESSAGE_RESET_POSITION
} from "@/store/mutations.type";
import RoeModal from "@/components/_shared/Modal";
import RoeTooltip from "@/components/_shared/Tooltip";

export default {
  name: "RoePlanDesignEditForm",
  components: { RoeModal, RoeTooltip },
  props: {
    name: {
      type: String,
      required: true
    },
    labels: {
      type: Array,
      required: false
    },
    tooltipData: {
      type: Function,
      required: false,
      default() {
        return false;
      }
    },
    designs: {
      type: Array,
      required: true
    },
    viewInput: {
      type: Function,
      required: true
    },
    form: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      "editableDesign",
      "editableDesignFieldName",
      "highlightDifferences",
      "errorMessage"
    ])
  },
  methods: {
    open(design) {
      this.form.$reset();
      this.$store.commit(ALTERNATIVE_DESIGNS_EDIT, {
        design: design,
        fieldName: this.name
      });
      this.$store.commit(HIDE_FORM_ERRORS);
      this.$refs.rightPanel.open();
      this.$store.commit(FLASH_MESSAGE_SET_POSITION, "left bottom");
    },
    save() {
      if (this.form.$invalid) {
        this.$store.commit(SHOW_FORM_ERRORS);
        this.flashMessage.error({ title: "Error", message: this.errorMessage });
      } else {
        this.$store.dispatch(ALTERNATIVE_DESIGN_UPDATE, {
          design: this.editableDesign
        });
        this.close();
      }
    },
    close() {
      if (this.$refs.rightPanel.close()) {
        this.$store.commit(FLASH_MESSAGE_RESET_POSITION);
        this.$store.commit(SET_INVALID_FORM_STATE, {
          errorMessage: "Please, calculate the data before continue"
        });
        this.form.$reset();
        setTimeout(
          () => this.$store.commit(ALTERNATIVE_DESIGNS_RESET_EDITABLE),
          200
        );
      }
    }
  }
};
</script>
